export const addLocalStorage = (key:string, value:string) => {
  return new Promise((resolve:any, reject) => {
    try {
      localStorage.setItem(key, value)
      resolve()
    } catch (e) {
      reject(e)
    }
  })
}

export const getLocalStorage = (key:string) => {
  return localStorage.getItem(key)
}

export const removeLocalStorage = (key:string) => {
  return localStorage.removeItem(key)
}

export const clearLocalStorage = () => {
  return localStorage.clear()
}

export const clearGame = () => {
  removeLocalStorage('gameCode')
  removeLocalStorage('passwordTemp')
  removeLocalStorage('localAnswers')
  removeLocalStorage('currentParent')
  removeLocalStorage('currentChildren')
  removeLocalStorage('currentMission')
  removeLocalStorage('gameTitle')
  removeLocalStorage('soundIsActivated')
  removeLocalStorage('tourWasCompleted')
  removeLocalStorage('greetings')
  removeLocalStorage('team')
}
